import { createSelector } from "reselect"
import { get, chain } from "lodash"

const getFactorCovariance = state => get(state, "global.data.factorVolatility.data.model.factors")

export const getVolatility = createSelector(
  [getFactorCovariance],
  (covariance) => chain(covariance)
    .keyBy(f => f.id)
    .mapValues(f => chain(f)
      .get("covariance.factors")
      .find(f2 => f.id === f2.id)
      .get("annualizedPercentSquared")
      .thru(Math.sqrt)
      .value())
    .value(),
)
